const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Account = () => import("@/views/orderstock");

// 详情

const Details = () => import("@/views/orderstock/detail.vue");


export default [
    {
        path: "/deliveryList",
        name: "deliveryList",
        component: Main,
        meta: {
            name: "出库信息列表",
            unfold: false, //是否可以被展开
            iconType: "usergroup-add"
        },
        redirect: {
            name: "deliveryList"
        },
        children: [
            {
                path: "deliveryList",
                name: "deliveryList",
                component: Account,
                meta: {
                    name: "出库信息列表",
                    role:{},
                }
            },
            {
                path: "deliveryDetails",
                name: "deliveryDetails",
                component: Details,
                meta: {
                    name: "出库信息列表/详情",
                    role:{},
                }
            }
        ]
    }
];